/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';

import PerfectScrollbar from 'react-perfect-scrollbar';
class ChannerlInfo extends Component {
  state = {
    city: '0',
    gun: '0',
  };
  componentDidMount = () => {
    //this._cityChange()
  };
  _onClose = () => {
    const { setChannelShow } = this.props;
    setChannelShow(false);
  };
  _cityChange = async (e) => {
    const cityCode = e.target.value;
    const result = await this._cityChangeApi(cityCode);
    const intReturn = result.data[0].intReturn;
    const gunList = result.data[0].listData;
    if (intReturn === 0) {
      this.setState({
        gunList,
        gunList1: gunList,
        city: cityCode,
        f1: false,
        f2: false,
      });
    }
  };
  _cityChangeApi = (cityCode) => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + '/channelLocation', {
        params: {
          city: cityCode,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  _gunChange = async (e) => {
    const { gunList } = this.state;
    const gunCode = e.target.value;
    let list;
    if (gunCode === '0') {
      list = gunList;
    } else {
      list = gunList.filter((item, index) => {
        //console.log(item.channelCode)
        return item.channelCode === parseInt(gunCode);
      });
    }

    this.setState({
      gunList1: list,
      gun: gunCode,
    });
    ////console.log(e.target.text)
    //const { city } = this.state
  };
  /*
    _gunChangeApi = () => {
        const { apiUrl } = this.props;
     
        return axios.post(apiUrl + '/channelLocation', {
            params: {
                city: cityCode
            }
        }) 
        .then(response => response)
        .catch(error => {
            alert('오류가 발생했습니다.')
        })
    }
    */
  _gunItem = () => {
    const { gunList } = this.state;

    const list = gunList.map((item, index) => {
      return (
        <option value={item.channelCode} key={index}>
          {item.location}
        </option>
      );
    });

    return list;
  };
  _getChanneItem = () => {
    const { gunList1 } = this.state;

    const list = gunList1.map((item, index) => {
      return (
        <tr key={index}>
          <td>
            <span>{item.location}</span>
          </td>
          <td>
            <em>{item.name}</em>
          </td>
          <td>
            <span></span>
            {item.etc}
          </td>
          <td>
            <em>{item.channelNumber}</em>
          </td>
        </tr>
      );
    });

    return list;
  };
  _mouseOn = (index) => {
    this.setState({
      f1: index === 1 ? true : false,
      f2: index === 2 ? true : false,
    });
  };
  _onMouseOut = (index) => {
    this.setState({
      f1: index === 1 && false,
      f2: index === 2 && false,
    });
  };
  render() {
    const { city, gun, gunList, gunList1, f1, f2 } = this.state;
    return (
      <Fragment>
        <div className="pairing_content">
          <div className="close_btn">
            <a style={{ cursor: 'pointer' }} onClick={this._onClose}>
              닫기
            </a>
          </div>
          <div className="pairing_group_channel">
            <h1>지역별 채널안내</h1>
            <div className="chanel_group">
              <div className="left_layer">
                <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <td>
                        <span>위성/IPTV</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="right_layer">
                <div className="div_title">
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="0"
                    cellPadding="0"
                  >
                    <tbody>
                      <tr>
                        <th>서비스지역</th>
                        <th>방송사명</th>
                        <th>고객센터</th>
                        <th>채널번호</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="div_scrol1">
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="0"
                    cellPadding="0"
                  >
                    <tbody>
                      <tr>
                        <td>
                          <span>전국</span>
                        </td>
                        <td>
                          <em>SKYLIFE</em>
                        </td>
                        <td>
                          <span></span>1588-3002
                        </td>
                        <td>
                          <em>CH.484</em>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>전국</span>
                        </td>
                        <td>
                          <em>Genie TV</em>
                        </td>
                        <td>
                          <span>국번없이</span>100
                        </td>
                        <td>
                          <em>CH.990</em>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>전국</span>
                        </td>
                        <td>
                          <em>LG U+</em>
                        </td>
                        <td>
                          <span>국번없이</span>101
                        </td>
                        <td>
                          <em>CH.328</em>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>전국</span>
                        </td>
                        <td>
                          <em>SK</em>
                        </td>
                        <td>
                          <span>국번없이</span>106
                        </td>
                        <td>
                          <em>CH.176</em>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="chanel_group">
              <div className="left_layer">
                <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <td>
                        <span>지역별 케이블 TV</span>
                        <p>
                          지역검색을 하시려면
                          <br />
                          아래를 선택하세요.
                        </p>
                        <div>
                          <select
                            name=""
                            value={city}
                            onChange={this._cityChange}
                            onMouseEnter={() => this._mouseOn(1)}
                            onMouseLeave={() => this._onMouseOut(1)}
                            className={
                              f1
                                ? 'select_input chanel_s_on'
                                : 'select_input chanel_s_off'
                            }
                          >
                            <option value="0">시/도</option>
                            <option value="1">서울특별시</option>
                            <option value="2">강원도</option>
                            <option value="3">경기도</option>
                            <option value="4">경상도</option>
                            <option value="5">대구광역시</option>
                            <option value="6">대전광역시</option>
                            <option value="7">부산광역시</option>
                            <option value="12">울산광역시</option>
                            <option value="8">인천광역시</option>
                            <option value="9">전라도</option>
                            <option value="13">광주광역시</option>
                            <option value="10">제주도</option>
                            <option value="11">충청도</option>
                          </select>
                        </div>
                        <div>
                          <select
                            name=""
                            value={gun}
                            onChange={this._gunChange}
                            onMouseEnter={() => this._mouseOn(2)}
                            onMouseLeave={() => this._onMouseOut(2)}
                            className={
                              f2
                                ? 'select_input chanel_s_on'
                                : 'select_input chanel_s_off'
                            }
                          >
                            <option value="0">구/군/시</option>
                            {gunList ? this._gunItem() : null}
                          </select>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="right_layer">
                <div className="div_title">
                  <table
                    width="100%"
                    border="0"
                    cellSpacing="0"
                    cellPadding="0"
                  >
                    <tbody>
                      <tr>
                        <th>서비스지역</th>
                        <th>방송사명</th>
                        <th>고객센터</th>
                        <th>채널번호</th>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="div_scroll2">
                  <PerfectScrollbar>
                    <table
                      width="100%"
                      border="0"
                      cellSpacing="0"
                      cellPadding="0"
                    >
                      <tbody>{gunList1 ? this._getChanneItem() : null}</tbody>
                    </table>
                  </PerfectScrollbar>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ChannerlInfo));
